import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { uniqBy } from 'lodash';

class TaskAssociations extends React.Component {
  static propTypes = {
    associations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })).isRequired,
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]).isRequired
  };

  render() {
    if (this.usableAssociations().length === 0) {
      return "";
    } else {
      return this.renderAssociationNames();
    }
  }

  usableAssociations() {
    const { associations } = this.props;
    return uniqBy(
      associations.filter(association => association.url !== null),
      association => [association.associatedModelType, association.originalId].join('#')
    );
  }

  renderAssociationNames() {
    const associations = this.usableAssociations();
    
    if (associations.length > 1) {
      const [firstAssociation, ...remainingAssociations] = associations;

      return (
        <React.Fragment>
          <a
            className="label pill-label label-on-market text-capitalize"
            href={firstAssociation.url}
          >
            {firstAssociation.name}
          </a>
          &nbsp;
          {this.renderAssociationOverlay(remainingAssociations)}
        </React.Fragment>
      );
    } else {
      const [firstAssociation] = associations;

      return (
        <a
          className="label pill-label label-on-market text-capitalize"
          href={firstAssociation.url}
        >
          {firstAssociation.name}
        </a>
      );
    }
  }

  renderAssociationOverlay(associations) {
    const popoverId = `popover-note-${this.props.id}`;

    const popoverContent = associations.map((association) => {
      return (
        <div className='my-2' key={association.id}>
          <a href={association.url}>{association.name}</a>
        </div>
      );
    });

    return (
      <OverlayTrigger
        overlay={<Popover id={popoverId} name="more-associations-popover">{popoverContent}</Popover>}
        placement="right"
        rootClose
        trigger="click"
        onClick={e => e.stopPropagation()}
      >
        <a href="#" name="and-more-link" onClick={e => e.preventDefault()}>
          and {associations.length} more&hellip;
        </a>
      </OverlayTrigger>
    );
  }
}

export default TaskAssociations;
